/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const mdSize = {height: 11, h: 11, borderRadius: 'base'}
import InputStyles from './input';

export default {
    sizes: {
        md: {
            field: mdSize
        }
    },
    variants: {
        outline: {
            field: {
                ...InputStyles.variants.outline.field,
                borderColor: 'gray.800',
                _disabled: {
                    opacity: 1,
                    color: 'gray.700',
                    background: 'gray.450'
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        },
        webSelect: (props) => ({
            field: {
                ...(props?.theme?.textStyles?.bodyMdRegular || {}),
                width: '100%',
                height: '48px',
                minH: '48px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: 0,
                borderColor: 'webTheme.strokeSecondary',
                paddingLeft: 2,
                paddingRight: '36px',
                paddingTop: '22px',
                paddingBottom: '4px',
                bg: 'webTheme.fieldDefault',
                color: 'webTypo.textPrimary',
                _hover: {
                    borderColor: 'webTheme.strokeSecondary'
                },
                _focusVisible: {
                    boxShadow: 'none',
                    outline: 'none'
                },
                _invalid: {
                    borderColor: 'webTheme.strokeWarning',
                    boxShadow: 'none',
                    _focusVisible: {
                        boxShadow: 'none',
                        outline: 'none'
                    }
                },
                _disabled: {
                    opacity: 1,
                    bg: 'webTheme.fieldDisabled',
                    borderColor: 'webTypo.textDisabled',
                    color: 'webTypo.textDisabled',
                    cursor: 'not-allowed',
                    _hover: {
                        borderColor: 'webTypo.textDisabled'
                    }
                }
            },
            icon: {
                position: 'absolute',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
                fontSize: '14px',
                right: '14px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'webTypo.textPrimary'
            }
        })
    }
}
